import { renderHost } from './renderHost';
import { state } from './state';

export const hideUi = (): void => {
    if (state.current.kind === 'empty') return;

    // Start fade out
    renderHost(false);

    // After fade completes, remove content (render null)
    state.hideTimer = window.setTimeout(() => {
        state.current = { kind: 'empty' };
        renderHost(false); // nothing shown
        state.hideTimer = null;
    }, state.fadeMs);
};
